module.exports = __webpack_public_path__ + "assets/img/title_4.3bb720a1.png";